import { render, staticRenderFns } from "./LanguageSwitch.vue?vue&type=template&id=9f649ecc&"
import script from "./LanguageSwitch.controller.js?vue&type=script&lang=js&"
export * from "./LanguageSwitch.controller.js?vue&type=script&lang=js&"
import style0 from "./LanguageSwitch.styles.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports